import { ContactForm } from "../components/ContactForm";
import { InnerPageHero } from "../components/InnerPageHero";

export function ContactPage() {
  const sponsorInquiry =
    new URLSearchParams(window.location.search).get("type") === "sponsor";
  const query = new URLSearchParams(window.location.search);
  const questInquiry = query.get("type") === "job-quest";
  const questNumber = query.get("quest") ?? "";
  const questMessage = /^[1-9][0-9]{0,5}$/.test(questNumber)
    ? `AIYSS Job Quest / QUEST #${questNumber.padStart(3, "0")}について\nhttps://aiyss.org/job-quest/quests/${questNumber}/\n\nご質問：\n`
    : "";

  return (
    <main id="top">
      <InnerPageHero kicker="AIYSS / CONTACT" title="お問い合わせ" />
      <section
        className="contact-section"
        id="contact"
        aria-labelledby="contact-title"
      >
        <div className="content-width contact-inner">
          <p className="section-index">CONTACT AIYSS</p>
          <h2 id="contact-title">
            AIYSSへの
            <br />
            <span>お問い合わせ</span>
          </h2>
          <p>
            AIYSSの活動、年間リーグ、取材、スポンサー協賛、企業との連携などについて、まずはお気軽にご連絡ください。
          </p>
          <ContactForm
            defaultInquiryType={
              sponsorInquiry
                ? "スポンサー協賛について"
                : questInquiry
                  ? "Job Questについて"
                  : undefined
            }
            lockInquiryType={sponsorInquiry || questInquiry}
            defaultMessage={questInquiry ? questMessage : ""}
          />
        </div>
      </section>
    </main>
  );
}
